<template>
    <div :class="['flex flex-1 h-full flex-col w-full', classList]">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'FullScreenPanelContent',
        props: {
            classList: {
                type: String,
                default: '',
            },
        },
    };
</script>